import { addItem } from '~/src/features/domofon/purchase/actions/addItem';
import { confirmContactDetails } from '~/src/features/domofon/purchase/actions/confirmContactDetails';
import creatingOrder from '~/src/features/domofon/purchase/actions/creatingOrder';
import decrementItem from '~/src/features/domofon/purchase/actions/decrementItem';
import fillContactDetails from '~/src/features/domofon/purchase/actions/fillContactDetails';
import fillPerson from '~/src/features/domofon/purchase/actions/fillPerson';
import fillPhone from '~/src/features/domofon/purchase/actions/fillPhone';
import finalization from '~/src/features/domofon/purchase/actions/finalization';
import flushOrderProcessing from '~/src/features/domofon/purchase/actions/flushOrderProcessing';
import incrementItem from '~/src/features/domofon/purchase/actions/IncrementItem';
import { initialized } from '~/src/features/domofon/purchase/actions/initialization';
import { onDeliveryAddressSelectedAction } from '~/src/features/domofon/purchase/actions/onDeliveryAddressSelected';
import onDeliveryAddressSelection from '~/src/features/domofon/purchase/actions/onDeliveryAddressSelection';
import orderCreated from '~/src/features/domofon/purchase/actions/orderCreated';
import orderProcessingFailed from '~/src/features/domofon/purchase/actions/orderProcessingFailed';
import { removeItem } from '~/src/features/domofon/purchase/actions/removeItem';
import selectCost from '~/src/features/domofon/purchase/actions/selectCost';
import setStage from '~/src/features/domofon/purchase/actions/setStage';
import { submitOrder } from '~/src/features/domofon/purchase/actions/submit';
import EEquipmentPurchaseActions from '~/src/features/domofon/purchase/constants/actions';
import contactDetailsReducer from '~/src/features/domofon/purchase/reducer/contactDetailsReducer';
import deliveryMethodReducer from '~/src/features/domofon/purchase/reducer/deliveryMethodReducer';
import equipmentReducer from '~/src/features/domofon/purchase/reducer/equipmentReducer';

import initialState, { InitialState } from './initialState';

export type TAllActions =
    | typeof addItem
    | typeof creatingOrder
    | typeof confirmContactDetails
    | typeof decrementItem
    | typeof fillContactDetails
    | typeof fillPerson
    | typeof fillPhone
    | typeof finalization
    | typeof flushOrderProcessing
    | typeof incrementItem
    | typeof initialized
    | typeof onDeliveryAddressSelectedAction
    | typeof onDeliveryAddressSelection
    | typeof orderCreated
    | typeof orderProcessingFailed
    | typeof removeItem
    | typeof selectCost
    | typeof setStage
    | typeof submitOrder;

// eslint-disable-next-line complexity
const reducer = (
    state: InitialState = initialState,
    action: ReturnType<TAllActions>,
): InitialState => {
    switch (action.type) {
        case EEquipmentPurchaseActions.INITIALIZED: {
            return {
                ...state,
                equipments: action.payload.equipmentList,
                initialized: true,
                oneItemPurchaseType: action.payload.oneItemPurchaseType,
                _category: action.payload.category,
            };
        }
        case EEquipmentPurchaseActions.FINALIZATION: {
            return { ...initialState };
        }
        case EEquipmentPurchaseActions.ADD_ITEM:
        case EEquipmentPurchaseActions.INC_ITEM:
        case EEquipmentPurchaseActions.DEC_ITEM:
        case EEquipmentPurchaseActions.REMOVE_ITEM:
        case EEquipmentPurchaseActions.SELECT_COST: {
            return equipmentReducer(state, action);
        }
        case EEquipmentPurchaseActions.DELIVERY_ADDRESS_SELECTION:
        case EEquipmentPurchaseActions.DELIVERY_ADDRESS_SELECTED: {
            return deliveryMethodReducer(state, action);
        }
        case EEquipmentPurchaseActions.FILL_CONTACT_DETAILS: {
            return {
                ...state,
                person: action.payload.person,
                phone: action.payload.phone,
            };
        }
        case EEquipmentPurchaseActions.FILL_PERSON:
        case EEquipmentPurchaseActions.FILL_PHONE:
        case EEquipmentPurchaseActions.CONFIRM_CONTACT_DETAILS:  {
            return contactDetailsReducer(state, action);
        }
        case EEquipmentPurchaseActions.ORDER_IS_BEING_PROCESSED: {
            return {
                ...state,
                isOrderBeingProcessed: true,
            };
        }
        case EEquipmentPurchaseActions.ORDER_CREATED: {
            return {
                ...state,
                isOrderCreated: true,
                createdOrderId: action.payload,
            };
        }
        case EEquipmentPurchaseActions.ORDER_PROCESSING_FAILED: {
            return {
                ...state,
                isOrderBeingProcessed: false,
                isOrderCreated: false,
            };
        }
        case EEquipmentPurchaseActions.FLUSH_ORDER_PROCESSING: {
            return {
                ...state,
                isOrderBeingProcessed: false,
                isOrderCreated: null,
            };
        }
        case EEquipmentPurchaseActions.SET_STAGE: {
            return {
                ...state,
                stage: action.payload,
            };
        }
        default:
            return state;
    }
};

export {
    reducer as default,
    initialState,
};

export type { InitialState };
